import React from 'react'

const Step = () => {
    return (
        <section>
            <div className="container">
                <div className="row">
                    <div className="order-12 order-md-1 col-md-6 my-auto pr-lg-5">
                        <p className="semi-bold font__size--14 text__14-1024 color__orange text-uppercase">Nasıl Çalışıyoruz</p>
                        <h3 className="bold font__size--58 text__50-1024 text__50-sm text__50-xs text-uppercase mb-4">3 Basit Adımda Kalite</h3>

                        <div className="d-flex align-items-start">
                            <img src="./../images/consulting.png" className='object-fit-content' alt="" />
                            <div className='ml-3'>
                                <h4 className='medium font__size--20 text__20-1024 text-uppercase'>Alan Analiziyle Başlayın, En İdeal Çözümleri Belirleyin!</h4>
                                <p className='normal font__size--16 text__16-1024 color__gray-1 roboto'>Bu adımda, müşterilerin ihtiyaçlarına uygun en uygun güvenlik çözümlerini belirlemek için profesyonel bir alan analizi yapıyoruz. Bu sayede müşterilerimizin özel taleplerine ve bölgenin özelliklerine göre en etkili çit seçeneklerini sunuyoruz.</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-start my-4">
                            <img src="./../images/planning.png" className='object-fit-content' alt="" />
                            <div className='ml-3'>
                                <h4 className='medium font__size--20 text__20-1024 text-uppercase'>Özelleştirilmiş Planlama, Güvenliği Tesis Edin!</h4>
                                <p className='normal font__size--16 text__16-1024 color__gray-1 roboto'>Müşterilerimizin güvenlik ihtiyaçlarını anlamak için etkili bir iletişim kuruyoruz ve onlarla işbirliği yaparak özelleştirilmiş bir planlama süreci başlatıyoruz. Bu sayede, her bir müşterimizin ihtiyaçlarına tam olarak uygun, güvenliği en üst düzeye çıkaran çözümler tasarlıyoruz.</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-start">
                            <img src="./../images/checking.png" className='object-fit-content' alt="" />
                            <div className='ml-3'>
                                <h4 className='medium font__size--20 text__20-1024 text-uppercase'>Uzman Ekibimizle Montaj ve Son Kontrol, Mutluluğa Adım Atın!</h4>
                                <p className='normal font__size--16 text__16-1024 color__gray-1 roboto'>Özenle hazırlanan çit sistemlerimizi, deneyimli ve uzman ekibimiz tarafından güvenilir bir şekilde monte ediyoruz. Son kontrollerimizle her detayın doğru işlediğinden emin oluyor ve müşterilerimize huzurlu bir yaşam alanı sunuyoruz. Müşteri memnuniyeti odaklı çalışmalarımızla, güvenlik standartlarını yükseltiyoruz.</p>
                            </div>
                        </div>
                    </div>
                    <div className="order-md-12 order-1 mb-4 col-md-6 col-lg-5 my-md-auto text-right">
                        <img src="./../images/sdsadas.png" className="w-100" alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Step